import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Textarea } from '@components/core-ui/form-elements/Textarea';
import { useAPI } from '@providers/useAPI';
import { useAuthContext } from '@providers/AuthProvider';
import { JobResponseDto, JobsService } from 'app/API';
import React from 'react';

import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { Content } from './EditJobNotesModal/styles/Content';

type TProps = {
  job: JobResponseDto;
  onCancel: () => void;
  onSuccess: () => void;
};

export const EditJobNotesModal = ({ job, onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const { workspace } = useAuthContext();
  const [notes, setNotes] = React.useState(job.notes ?? '');

  const handleSubmit = async () => {
    const workspaceId = job.workspaceId ?? workspace?.id ?? '';
    await call(JobsService.editJobNotes({ wsid: workspaceId, jobId: job.id, requestBody: { notes } }));
    onSuccess();
  };

  const onInputChange = async (evt: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { value } = evt.target;
    await setNotes(value);
  };

  return (
    <ModalWrapper width="487px">
      <ModalTitle>Edit Job Notes</ModalTitle>
      <Content>
        <Textarea onChange={onInputChange} name="notes" label="Type your notes here" value={notes} />

        <div className="buttonGroup">
          <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
          <Button onClick={handleSubmit}>Save</Button>
        </div>
      </Content>
    </ModalWrapper>
  );
};
